import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Axios from 'axios';  
import { useEffect, useState } from 'react'
import { domain } from '../env';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import FsLightbox from 'fslightbox-react';

export const MediaGalleryEn = () => {
    const [mediagallery, setMediagallery] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Lightbox states
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    const openLightboxOnSlide = (number) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    };

    const mediagalleryget = async () => {
        setLoading(true);
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/mediagallery/?page=1`  // Get first page only for homepage carousel
            });
            
            if (response.data && response.data.results) {
                setMediagallery(response.data.results);
            } else {
                setMediagallery([]);
            }
            console.log(response.data, "media gallery data");
        } catch (error) {
            console.error("Error fetching media gallery:", error);
            setMediagallery([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        mediagalleryget();
    }, []);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 800 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 800, min: 0 },
            items: 1
        }
    };

    // Create an array of image sources for the lightbox
    const lightboxSources = Array.isArray(mediagallery) 
        ? mediagallery.map(item => `${domain}${item?.image}`) 
        : [];

    return (
        <>
            <section className="gallery-page gallery--carousel">
                <div className="container">
                    <div className="section-title text-left">
                        <h2 className="section-title__title">Media Gallery..</h2>
                    </div>
                    
                    {loading ? (
                        <div className="text-center py-3">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <Carousel 
                            responsive={responsive} 
                            autoPlay={true} 
                            keyBoardControl={true} 
                            ssr={true} 
                            swipeable={true} 
                            infinite={true}
                            itemClass="carousel-item-padding"
                        >
                            {Array.isArray(mediagallery) && mediagallery.map((mg, index) => (
                                <div className="gallery-card" key={index}>
                                    <div 
                                        onClick={() => openLightboxOnSlide(index + 1)}
                                        style={{ cursor: 'pointer' }}
                                        className="gallery-item"
                                    >
                                        <LazyLoadImage 
                                            effect="blur" 
                                            src={`${domain}${mg?.image}`}
                                            alt={`Gallery image ${index + 1}`}
                                            width="100%"
                                            height="280px"
                                            style={{
                                                objectFit: 'cover',
                                                border: '1px solid #e570e7',
                                                borderStyle: 'dashed',
                                                marginTop: '10px',
                                                display: 'block'
                                            }}
                                            placeholderSrc={`data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjI4MHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YxZjFmMSIvPjx0ZXh0IHRleHQtYW5jaG9yPSJtaWRkbGUiIHg9IjUwIiB5PSI1MCIgc3R5bGU9ImZpbGw6I2JiYjsgZm9udC1mYW1pbHk6IEFyaWFsLCBzYW5zLXNlcmlmOyBmb250LXNpemU6IDE1cHg7IGRvbWluYW50LWJhc2VsaW5lOiBtaWRkbGU7Ij5Mb2FkaW5nLi4uPC90ZXh0Pjwvc3ZnPg==`}
                                        />
                                        <div className="gallery-item__overlay">
                                            <span className="icon-plus"></span>
                                            <p className="mt-2 text-light">Click to view</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}
                    
                    {/* FsLightbox component */}
                    <FsLightbox
                        toggler={lightboxController.toggler}
                        sources={lightboxSources}
                        slide={lightboxController.slide}
                        type="image"
                        showThumbsOnMount={true}
                        disableLocalStorage={false}
                        className="gallery-lightbox"
                    />
                </div>
            </section>
            
            {/* Add CSS for gallery item overlay */}
            <style dangerouslySetInnerHTML={{
                __html: `
                    /* Enhanced gallery grid styles */
                    .carousel-item-padding {
                        padding: 0 10px;
                        display: flex;
                        justify-content: center;
                    }

                    .gallery-card {
                        width: 100%;
                        position: relative;
                        overflow: hidden;
                        padding-bottom: 15px;
                    }

                    .gallery-item {
                        position: relative;
                        overflow: hidden;
                        width: 100%;
                        height: 280px;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                        transition: transform 0.3s;
                        border-radius: 8px;
                        background-color: #f8f9fa;
                    }

                    .gallery-item:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
                    }

                    .gallery-item img {
                        width: 100% !important;
                        height: 280px !important;
                        object-fit: cover !important;
                        border-radius: 8px;
                        display: block;
                    }

                    .gallery-item__overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0,0,0,0.5);
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        opacity: 0;
                        transition: opacity 0.3s;
                        margin-top: 10px;
                        border-radius: 8px;
                    }

                    .gallery-item:hover .gallery-item__overlay {
                        opacity: 1;
                    }

                    .gallery-item .icon-plus {
                        color: white;
                        font-size: 24px;
                    }

                    .fslightbox-toolbar-button:nth-child(1) {
                        display: block !important;
                    }

                    .fslightbox-slide-btn {
                        background-color: rgba(255, 255, 255, 0.3);
                        border-radius: 50%;
                    }
                    
                    @media (max-width: 768px) {
                        .gallery-item__overlay {
                            opacity: 0.7;
                        }
                    }
                `
            }} />
        </>
    );
};
